import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "offer-banner",
  label: "Offer Banner",
  description: "Full-width promotional banner with background image and text overlay.",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "V1 — Full-Width Promo Banner",
      fields: [
        { key: "image", label: "Background Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "Special Offer" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Get up to 50% off on selected items" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        { key: "overlayOpacity", label: "Overlay Opacity (0–100)", type: "number", default: 50 },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
